export default "__VITE_ASSET__Ce_BF_Gx__"